import { render, staticRenderFns } from "./changepassowrd.vue?vue&type=template&id=4a95d921&scoped=true&"
import script from "./changepassowrd.vue?vue&type=script&lang=js&"
export * from "./changepassowrd.vue?vue&type=script&lang=js&"
import style0 from "./changepassowrd.vue?vue&type=style&index=0&id=4a95d921&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a95d921",
  null
  
)

export default component.exports